var map = {
	"./openapi.en_US.json": "./openapi.en_US.json",
	"./openapi.es_ES.json": "./openapi.es_ES.json"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./ recursive ^\\.\\/openapi\\..*\\.json$";


//////////////////
// WEBPACK FOOTER
// . ^\.\/openapi\..*\.json$
// module id = ./ recursive ^\.\/openapi\..*\.json$
// module chunks = 0